import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label, Error } from './styled';

const CLField = ({ label, error, field }) => (
  <Container>
    <Label>{label}</Label>
    {field()}
    {error?.length ? <Error>{error[0]}</Error> : null}
  </Container>
);

CLField.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.func.isRequired,
  error: PropTypes.array,
};

CLField.defaultProps = {
  error: [],
};

export default CLField;
